import React from "react";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { withTranslation } from "react-i18next";
import withRouter from "../../../components/Common/withRouter";
import { assignAdvancedSalary } from "../../../slice/thunks";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

const AssignAvancedSalary = (props) => {
  const { id, name } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const employeeName = decodeURIComponent(name || "");
  const employeeId = (id || "").toString();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: "",
      requestDate: "",
    },
    validationSchema: Yup.object({
      amount: Yup.number()
        .required("Amount is required")
        .min(1, "Amount must be at least 1"),
      requestDate: Yup.date().required("Request date is required"),
    }),
    onSubmit: (values) => {
      const payload = {
        employeeId: employeeId,
        amount: Number(values.amount),
        requestDate: values.requestDate,
      };
      // console.log("Payload envoyé :", payload);

      dispatch(assignAdvancedSalary(payload))
        .unwrap()
        .then((res) => {
          toast.success(res.message || "Advanced salary successfully assigned!");
          navigate("/payroll/staff-management");
        })
        .catch((err) => {
          const errorMessage = err?.message || err || "An error occurred";
          toast.error(errorMessage);
        });
    },
  });

  return (
    <div className="all-payrollSettings-setting px-3">
      <div className="patients-list py-4 px-2">
        <div className="container-fluid">
          <div className="row list-patients d-flex justify-content-between">
            <div className="col-lg-5">
              <h6>{props.t("assign_advanced_salary")}</h6>
            </div>
          </div>

          <Card className="container p-0">
            <CardHeader className="bg-light p-3">
              {props.t("assign_advanced_salary")} {props.t("to")}{" "}
              <strong>{employeeName}</strong>
            </CardHeader>

            <Form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <CardBody>
                <div className="container">
                  <Row>
                    <Col xl={6} sm={12}>
                      <div className="mb-3">
                        <Label className="form-label">Amount *</Label>
                        <Input
                          type="number"
                          name="amount"
                          value={validation.values.amount}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.amount &&
                            !!validation.errors.amount
                          }
                        />
                        <FormFeedback>{validation.errors.amount}</FormFeedback>
                      </div>
                    </Col>

                    <Col xl={6} sm={12}>
                      <div className="mb-3">
                        <Label className="form-label">Request Date *</Label>
                        <Input
                          type="date"
                          name="requestDate"
                          value={validation.values.requestDate}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.requestDate &&
                            !!validation.errors.requestDate
                          }
                        />
                        <FormFeedback>
                          {validation.errors.requestDate}
                        </FormFeedback>
                      </div>
                    </Col>
                  </Row>
                </div>
              </CardBody>

              <CardFooter>
                <div className="p-3">
                  <Row className="align-items-center">
                    <div className="col-sm">
                      <span className="text-danger align-middle">
                        * : Required fields
                      </span>
                    </div>
                    <div className="col-sm-auto">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => navigate(-1)}
                        >
                          {props.t("close")}
                        </button>
                        <button type="submit" className="btn btn-success">
                          {props.t("save")}
                        </button>
                      </div>
                    </div>
                  </Row>
                </div>
              </CardFooter>
            </Form>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default withRouter(withTranslation()(AssignAvancedSalary));
